<template>
  <div
    class="
      yx-handle-required-page yx-handle-family-page
      predicted-item-page
      main-layout
    "
    v-loading="handleLoading"
  >
    <el-card class="box-form box-inner box-bg">
      <c-title slot="header" title="主要社会关系"></c-title>

      <div class="pb90">
        <div class="div-scroll" style="padding: 20px">
          <el-row :gutter="20" class="family-row-title">
            <el-col
              :span="item.span"
              v-for="(item, index) in formItems"
              :key="index"
            >
              <span class="red">*</span>
              {{ item.label }}
            </el-col>
            <el-col :span="1"
              ><i class="el-icon-circle-plus-outline" @click="handleAdd"></i
            ></el-col>
          </el-row>

          <el-row
            v-for="(data, k) in pageData"
            :key="k"
            :gutter="20"
            class="family-row-data"
          >
            <el-form
              :model="data"
              :rules="formRules"
              label-width="0"
              :ref="'refForm' + k"
              :disabled="disabled"
            >
              <el-col :span="3">
                <el-form-item prop="name">
                  <el-input v-model="data.name"></el-input> </el-form-item
              ></el-col>
              <el-col :span="3">
                <el-form-item prop="relationship">
                  <el-input v-model="data.relationship"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item prop="unit">
                  <el-input
                    v-model="data.unit"
                    maxlength="15"
                    :show-word-limit="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item prop="dateBirth">
                  <!-- <el-input v-model.number="data.age"></el-input> -->
                  <el-date-picker
                    v-model="data.dateBirth"
                    type="date"
                    placeholder="选择日期"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item prop="politicalCode">
                  <!-- <el-input v-model="data.politicalCode"></el-input> -->
                  <el-select v-model="data.politicalCode" filterable>
                    <el-option
                      v-for="item in _POLITICAL"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item prop="contactPhone">
                  <el-input v-model="data.contactPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item prop="nationCode">
                  <!-- <el-input v-model="data.nationCode"></el-input> -->
                  <el-select v-model="data.nationCode" filterable>
                    <el-option
                      v-for="item in _NATION"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item prop="job">
                  <el-input
                    v-model="data.job"
                    maxlength="5"
                    :show-word-limit="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1"
                ><i
                  class="el-icon-remove-outline"
                  @click="handleDelete(k)"
                  v-if="k > 0"
                ></i>
              </el-col>
            </el-form>
          </el-row>

          <div class="s-btn">
            <el-button
              type="primary"
              size="large"
              @click="confirm"
              :disabled="isSubmit || disabled"
              >保存</el-button
            >
          </div>
          <div class="tips-container">
            <div class="tips">
              <div class="title">
                <i class="el-icon-info"></i><span>温馨提示</span>
              </div>
              <p>1、简述主要社会关系的姓名，政治面貌及职业信息；</p>
              <p>2、社会关系填写数量≤3；</p>
              <p>注：填写的内容将纳入个人档案，请谨慎填写确保信息真实有效。</p>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Configs from "../data/relation.js";
import { isPhone } from "@/libs/checker.js";
import { mapState } from "vuex";
export default {
  name: "",
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      index: "",
      defaultHandleData: {
        relationship: "",
        name: "",
        dateBirth: "",
        nation: "",
        politicalCode: "",
        unit: "",
        contactPhone: "",
        job: "",
      },
      pageData: [],
      isSubmit: false,
      options: [
        "父亲",
        "母亲",
        "哥哥",
        "弟弟",
        "姐姐",
        "妹妹",
        "祖父母",
        "外祖父母",
        "其他亲属",
      ],
      validAll: true,
      handleLoading: false,
    };
  },
  computed: {
    ...mapState("dic", ["_POLITICAL", "_NATION", "SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  mounted() {
    this.getFamilyData();
  },
  methods: {
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          console.log(res);
          if (res) resolve();
          else {
            reject();
          }
        });
      });
    },

    // 删除家庭成员
    handleDelete(index) {
      this.pageData.splice(index, 1);
    },
    // 更新家庭成员信息
    saveInfo() {
      let params = this.pageData;
      this.isSubmit = true;
      this.handleLoading = true;
      this.$http
        .post("/account/base/student/relation/saveOrUpdate", params)
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("保存数据成功");
            this.$router.go(-1);
          } else {
            this.$message.error(`'保存数据成功' + ${res.msg}`);
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.isSubmit = false;
          this.handleLoading = false;
        });
    },
    confirm() {
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //数组部分的表单，用map返回验证函数的调用
        ...this.pageData.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
      ]).then((res) => {
        if (res) {
          // 全部表单验证通过
          console.log(res);
          this.$confirm("确定修改保存?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.saveInfo();
              // console.log(this.pageData)
            })
            .catch(() => {});
        }
      });
    },
    handleAdd() {
      if (this.pageData.length > 2) {
        this.$message.warning("最多可添加3个家庭成员信息！");
      } else {
        this.pageData.push({
          relationship: "",
          name: "",
          dateBirth: "",
          nation: "",
          politicalCode: "",
          unit: "",
          contactPhone: "",
          job: "",
        });
      }
    },
    // 获取全部家庭全部成员信息
    getFamilyData() {
      this.$http
        .get("/account/base/student/relation/myInfo")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            if (res.data.length) {
              this.pageData = res.data;
              // this.pageData[0].disabled = this.pageData[1].disabled = true;
            } else {
              this.handleAdd();
            }
          } else {
            this.handleAdd();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>